import React from "react"

const HTMLNodeEmail = ({ node }) => (
  <div dangerouslySetInnerHTML={{ __html: node.data.get("html") }} />
)

export default HTMLNodeEmail
